// extracted by mini-css-extract-plugin
export default {"control":"Codepopup_control__AW-TK"};